// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import ('../node_modules/vuetify/dist/vuetify.min.css')
import { store } from './store'
import * as firebase from 'firebase'
import VueFire from 'vuefire'

Vue.use(Vuetify)
Vue.use(VueFire)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },

  created () {
    firebase.initializeApp({
      apiKey: "AIzaSyCiRdT_DwzNINrj2VvsMm07YPN1wVIXABk",
      authDomain: "mygolfappvuejs.firebaseapp.com",
      databaseURL: "https://mygolfappvuejs.firebaseio.com",
      projectId: "mygolfappvuejs",
      storageBucket: "",
      messagingSenderId: "1095500639511"
    }),

    this.$store.dispatch('setActualYear'),

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        this.$store.dispatch('fetchHcp', user)
        this.$store.dispatch('loadActualRoundKey')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js